import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Header } from 'semantic-ui-react';
import server from '../../functions/server';
import userId from '../../functions/userid';
import $ from 'jquery';

export default class EditState extends React.Component {
  state = {
    open: false,
    state: ""
  };

  handleClose = () => {
    this.props.handleState({editstate: false});
  };

  handleUpdate = () => {
    let state = this.state.state.trim();
    if (state.length < 2) {
      this.setState({
        message: "Invalid State"
      });
      return;
    }
    let data = {
      id: this.props.id,
      owner: userId(),
      type: 'state',
      value: state
    }
    console.log(data);
    let context = this;
    $.ajax({
      type: 'POST',
      url: server() + "/shop/update.php",
      data: data,
      beforeSend: function(x) {
          context.setState({
            dimmer: true,
            loadText: "Updating Mobile Number"
          });
      },
      success: function(data, status) {
        let editstate = true;
        if (data == "1") {
          context.props.updateProps('state', state);
          editstate = false;
        }
        context.props.handleState({
          dimmer: false,
          loadText: "", editstate

        });
      },
      error: function(data, status) {
        context.props.handleState({
          dimmer: false,
          loadText: "",
          message: data
        });
      }
    });
  }

  render() {
    if (!this.state.state) {
      this.setState({
        state: this.props.state
      })
    }
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Update state Number</DialogTitle>
          <DialogContent>
            <DialogContentText>
              state Number
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="descriptionText"
              value={this.state.state}
              onChange={(e) => {this.setState({state: e.target.value, message:""})}}
              fullWidth
            />
            <Header as='h4' color='red'>
              {this.state.message}
            </Header>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleUpdate} color="primary">
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
